<template>
  <BaseSimpleModal
    :title="$t('disable_system_modal.title')"
    :fullHeight="false"
    :fitContent="true"
    @backdropClick="$emit('close')"
  >
    <div class="gap-row-sm disable-modal-body">
      <div class="gap-row-xs">
        <div class="qrw-label-lg qrw-text-content-base-primary">
          {{ $t('disable_system_modal.question') }}
        </div>
        <BaseBetaRadioButton
          v-model="selectedMode"
          checkedValue="manual"
        >
          {{$t('disable_system_modal.mode_manual')}}
        </BaseBetaRadioButton>
        <BaseBetaRadioButton
          v-model="selectedMode"
          checkedValue="auto"
        >
          {{$t('disable_system_modal.mode_auto')}}
        </BaseBetaRadioButton>
      </div>
      <BaseDivider
        color="border-base-tertiary"
        v-if="selectedMode == 'auto'"
      />
      <div
        class="gap-row-xs"
        v-if="selectedMode == 'auto'"
      >
        <div class="qrw-label-lg qrw-text-content-base-primary">
          {{$t('disable_system_modal.auto_date')}}
        </div>
        <div class="gap-column-xs timing-fields">
          <BaseDatepickerInput
            v-model="closeDate"
            inputSize="md"
            pickerSize="lg"
            :pickerFixedWidth="true"
          />
          <BaseTimepickerInput
            v-model="closeDate"
            size="md"
          />
        </div>
      </div>
      <BaseDivider
        color="border-base-tertiary"
        v-if="selectedMode == 'auto' && canDisablePreliminaryOrders"
      />
      <div
        class="gap-column-md"
        v-if="selectedMode == 'auto' && canDisablePreliminaryOrders"
      >
        <div class="gap-row-1xs w-100">
          <div class="qrw-label-lg qrw-text-content-base-primary">
            {{$t('disable_system_modal.preliminary_title')}}
          </div>
          <div class="qrw-label-md qrw-text-content-base-secondary">
            {{$t('disable_system_modal.preliminary_desc')}}
          </div>
        </div>
        <BaseBetaToggle
          v-model="allowPreliminaryOrders"
          size="sm"
        />
      </div>
    </div>
    <template #footer>
      <div class="disable-modal-footer">
        <div class="qrw-label-md qrw-text-content-base-secondary">
          {{ hintText }}
        </div>
        <BasePushButton
          variant="primary"
          bgColor="background-base-inverse-primary"
          textColor="content-base-inverse-primary"
          :disabled="!canConfirm"
          size="md"
          @click="confirm"
        >
          {{$t('disable_system_modal.confirm_btn')}}
        </BasePushButton>
      </div>

    </template>

  </BaseSimpleModal>
</template>

<script>
import moment from 'moment'

export default {
  data() {
    return {
      selectedMode: 'manual',

      closeDate: new Date(),
      allowPreliminaryOrders: true
    }
  },
  props: {
    system: String
  },
  methods: {
    confirm() {
      if (this.selectedMode == 'manual') {
        this.$emit('manual')
      } else {
        this.$store.commit('addCafeCloseRule', {
          system: this.system,
          start_date: new Date(),
          end_date: this.closeDate,
          allow_preliminary_orders: this.allowPreliminaryOrders
        })
        this.$store.dispatch('saveCafe')
      }

      this.$emit('close')
    }
  },
  computed: {
    hintText() {
      return this.selectedMode == 'manual'
        ? this.$t('disable_system_modal.hint_manual')
        : this.$t('disable_system_modal.hint_auto') + moment(this.closeDate).format('dddd, DD.MM.YYYY HH:mm')
    },
    canConfirm() {
      return this.selectedMode == 'manual' ? true : moment(this.closeDate).isAfter(moment().add('1', 'minute'))
    },
    canDisablePreliminaryOrders() {
      return this.system == 'preorder' || this.system === 'delivery'
    }
  }
}
</script>

<style scoped>
.disable-modal-body {
  padding: 24px;
  box-sizing: border-box;
}

.disable-modal-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  column-gap: 16px;
  width: 100%;
  box-sizing: border-box;
}

@media screen and (max-width: 600px) {
  .disable-modal-footer {
    padding: 12px;
    display: flex;
    flex-direction: column;
    row-gap: 16px;
  }

  .disable-modal-footer button {
    width: 100%;
  }

  .timing-fields {
    display: flex;
    flex-direction: column;
    row-gap: 16px;
  }
}
</style>